import { EVIDENCE_MAX_LENGTH, LABEL_MIXING_NOTE_MAX_LENGTH } from '../../constants';
import useTranslation from '../../hooks/useTranslation';

import { TextAreaInput, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { EVIDENCE_ROWS, MIXING_NOTE_ROWS, TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const FormulationEvidenceFields: FunctionComponent<Props> = ({
    className = '',
    evidence,
    isDisabled,
    labelMixingNote,
    onEvidenceChange,
    onLabelMixingNoteChange,
    testId = TEST_ID
}) => {
    const t = useTranslation();

    return (
        <VerticalContainer
            className={`${styles.formulationEvidenceFields} ${className}`}
            testId={testId}>
            <Wrapper className={styles.label}>{t.EVIDENCE_LABEL}</Wrapper>

            <TextAreaInput
                isDisabled={isDisabled}
                maxCharacters={EVIDENCE_MAX_LENGTH}
                onChange={onEvidenceChange}
                rows={EVIDENCE_ROWS}
                testId={`${testId}-evidence`}
                value={evidence}
            />

            <Wrapper className={styles.helper}>{t.EVIDENCE_HELPER}</Wrapper>

            <Wrapper className={styles.label}>{t.MIXING_NOTE_LABEL}</Wrapper>

            <TextAreaInput
                isDisabled={isDisabled}
                maxCharacters={LABEL_MIXING_NOTE_MAX_LENGTH}
                onChange={onLabelMixingNoteChange}
                rows={MIXING_NOTE_ROWS}
                testId={`${testId}-mixing-note`}
                value={labelMixingNote}
            />
        </VerticalContainer>
    );
};

export default FormulationEvidenceFields;
